// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import type SetMailboxJunkEmailConfigurationRequest from '../contract/SetMailboxJunkEmailConfigurationRequest';

export default function setMailboxJunkEmailConfigurationRequest(
    data: SetMailboxJunkEmailConfigurationRequest
): SetMailboxJunkEmailConfigurationRequest {
    const result: SetMailboxJunkEmailConfigurationRequest = {
        __type: 'SetMailboxJunkEmailConfigurationRequest:#Exchange',
        ...data,
    };

    return result;
}
